exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scoped-headhunterDetail .white-block{background:#fff;padding:20px;min-height:700px}.scoped-headhunterDetail .supplier-bottom{border:1px solid #2481ff;color:#999;padding:5px 20px;margin-top:-1px;border-radius:0 0 5px 5px}.scoped-headhunterDetail .banner-text{padding:15px 20px;border:1px solid #2481ff;background:#2481ff;color:#fff;border-radius:5px 5px 0 0}.scoped-headhunterDetail .subTitle{width:500px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-157a797f","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/supplier/supplierUsers.vue
// module id = 972
// module chunks = 23